.scrim {
  position: fixed;
  inset: 0;
  background: rgba(20, 18, 16, 0.55);
  z-index: 130;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--space-5);
}

.card {
  width: 100%;
  max-width: 540px;
  max-height: 90dvh;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.32);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.eyebrow {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--color-ink-soft);
}

.title {
  font-family: var(--font-display);
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.tag {
  display: inline-block;
  background: rgba(102, 67, 219, 0.12);
  color: #4928bd;
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
}

.close {
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--color-ink-soft);
  padding: 6px;
  display: inline-flex;
  align-items: center;
}

.close:hover { color: var(--color-ink); }

.body {
  padding: 18px 20px 20px;
  overflow-y: auto;
}

.mount { min-height: 380px; }

.loading { padding: 60px 20px; text-align: center; color: var(--color-ink-soft); }

.error {
  background: rgba(181, 59, 59, 0.08);
  border: 1px solid rgba(181, 59, 59, 0.4);
  color: #7a2828;
  padding: 12px 14px;
  border-radius: 6px;
  margin-bottom: 12px;
}

.error strong { font-size: 0.95rem; }
.error p { margin: 4px 0 0; font-size: 0.9rem; }

@media (max-width: 540px) {
  .scrim { padding: 0; align-items: flex-end; }
  .card { max-height: 92dvh; border-radius: 14px 14px 0 0; max-width: none; }
}
